import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Badge from '@components/ringil3/Badges/Badge';
import CustomTooltip from '@components/ringil3/Tooltip/CustomTooltip';
import { isNotNullOrUndefined } from '@utils/utils';
import { formatDateTimeInTzWithLocale } from '@utils/dateWithTz.tsx';
import { SecuredConfig, useSecuredDecoration } from '@components/security/securedDecoration';
import SvgRobot from '@icons/ai-robot.svg?react';

interface ComponentProps {
  firstChangeAt?: string;
  lastChangeAt?: string;
  timezoneId: string;
  dataTestId?: string;
  secured?: SecuredConfig;
}

const AiDispatcherChangeBadge: React.FC<ComponentProps> = ({ firstChangeAt, lastChangeAt, timezoneId, dataTestId, secured }) => {
  const { tr } = useTranslationLgs();
  const { decorate } = useSecuredDecoration(secured);
  return (
    <>
      {decorate(
        isNotNullOrUndefined(lastChangeAt) && (
          <span id="ai-dispatcher-change-badge">
            <CustomTooltip
              targetSelector="#ai-dispatcher-change-badge"
              content={
                <>
                  <div>{`${tr('AiDispatcherChangeBadge.firstChange', 'First AI Dispatcher change')}: ${formatDateTimeInTzWithLocale(firstChangeAt, timezoneId)}`}</div>
                  <div>{`${tr('AiDispatcherChangeBadge.lastChange', 'Last AI Dispatcher change')}: ${formatDateTimeInTzWithLocale(lastChangeAt, timezoneId)}`}</div>
                </>
              }
            />
            <Badge filled={false} highlightedValue={false}>
              <SvgRobot />
              <div data-testid={dataTestId}>{formatDateTimeInTzWithLocale(lastChangeAt, timezoneId)}</div>
            </Badge>
          </span>
        ),
      )}
    </>
  );
};

export default AiDispatcherChangeBadge;
